
import * as microsoftTeams from "@microsoft/teams-js";
import { IErrorprops } from "../hooks/types";
import browser from "browser-detect";
import { appSupportedConstants } from "./app-constants";

/**
 * To centrally collect the logs and log it in AWS server. Currently only logs are centrally collected using this function but its not logging in AWS server.
 * @param properties error details
 */
export const LogError = (properties: IErrorprops) => {
    microsoftTeams.app.getContext().then(context => {
        const { params } = properties;
        const parameters = {
            loggedInUserId: context?.user?.id,
            loggedInEmail: context?.user?.userPrincipalName,
            tenantId: context?.user?.tenant?.id,
            ...properties
        };
    });
}

/**
 * Calculate the random glow for the requested shelf
 * @param glowImagesList Array of glow images
 * @returns a randomly selected image
 */
export function RandomGlowImage(glowImagesList: []): string {
    const randomNumber = Math.floor(Math.random() * glowImagesList.length);
    return glowImagesList[randomNumber];
}

/**
 * Get browser details from the library browser detect and return true and false for supported and unsupported browsers
 * @returns 
 */
export const GetUnSupportedBrowser = () => {
    const result = browser();
    let isUnsupported = false;
    let unSupported = false;
    if (result.mobile === true) {
        for (const value of appSupportedConstants.os) {
            if (!result.os?.toLocaleLowerCase().includes(value)) {
                unSupported = true;
            } else {
                unSupported = false;
                break;
            }
        }
        isUnsupported = unSupported
    }
    else {
        for (const value of appSupportedConstants.os) {
            if (result.os !== undefined && !result.os?.toLocaleLowerCase().includes(value)) {
                unSupported = true;

            } else {
                unSupported = false;
                break;
            }
        }
        for (const value of appSupportedConstants.browsers) {
            if (result.name !== undefined && !result.name?.toLocaleLowerCase().includes(value)) {
                unSupported = true;
            } else {
                unSupported = false;
                break;
            }
        }
        isUnsupported = unSupported;
    }
    return isUnsupported;
}

